import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

interface ModeSelectorProps {
    mode: 'llm' | 'rag' | 'agent' | 'test';
    setMode: (mode: 'llm' | 'rag' | 'agent' | 'test') => void;
    startNewSession: () => void;
}

const ModeSelector: React.FC<ModeSelectorProps> = ({ mode, setMode, startNewSession }) => {
    const handleModeChange = (
        event: React.MouseEvent<HTMLElement>,
        newMode: 'llm' | 'rag' | 'agent' | 'test' | null
    ) => {
        if (newMode !== null) {
            setMode(newMode);
            startNewSession();
        }
    };

    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" gutterBottom color="black">
                モード選択:
            </Typography>
            <ToggleButtonGroup
                value={mode}
                exclusive
                onChange={handleModeChange}
                aria-label="mode selection"
                size="small"
                orientation="vertical"
                fullWidth
            >
                <ToggleButton value="llm" aria-label="LLM mode">
                    LLM
                </ToggleButton>
                <ToggleButton value="rag" aria-label="RAG mode">
                    RAG
                </ToggleButton>
                <ToggleButton value="agent" aria-label="Agent mode">
                    AGENT
                </ToggleButton>
                <ToggleButton value="test" aria-label="Test mode">
                    Test
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default ModeSelector;
